(() => {
  const breadcrumb_root = $('#bredcrumbWrapId');
  const breadcrumb_wrapper = $('#bredcrumbWrapId .breadcrumbs');
  const left_gradient = $('#bredcrumbWrapId .mobile-gradient.left');
  const right_gradient = $('#bredcrumbWrapId .mobile-gradient.right');

  if (breadcrumb_root.length && breadcrumb_root.data('tes') === 'product') {
    breadcrumb_root.removeClass('tw-hidden');
    console.log('Custom breadcrumb debug', {
      productHandle: breadcrumb_root.data('productHandle'),
      productVendor: breadcrumb_root.data('productVendor'),
      metafieldEnabled: breadcrumb_root.data('customBreadcrumbEnabled'),
      metafieldText: breadcrumb_root.data('customBreadcrumbText'),
      metafieldUrl: breadcrumb_root.data('customBreadcrumbUrl'),
      isCustomBreadcrumbRendered: breadcrumb_root.data('showCustomBreadcrumb')
    });
  }
  
  //Control when gradients should be displayed
  breadcrumb_wrapper.on("scroll", function() {
    const scroll_position = breadcrumb_wrapper.scrollLeft();
    if( scroll_position > 1){
      left_gradient.add(right_gradient).addClass('active');
    }else {
      left_gradient.add(right_gradient).removeClass('active');
    }
  });
})();
